import React from 'react';
import './StaticWebsiteDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Lightning-Fast Load Times",
    "Simple & Lightweight Architecture",
    "SEO-Friendly Structure",
    "No Database Required",
    "Secure & Hacker-Resistant",
    "Custom Design with HTML/CSS/JS",
    "Responsive & Mobile-Friendly",
    "Affordable Hosting Options"
];

const benefits = [
    "Low Maintenance Cost",
    "Quick Development Turnaround",
    "Ideal for Informational Pages",
    "Highly Reliable & Stable",
    "No Server-Side Vulnerabilities",
    "Easier to Deploy & Host",
    "Better Performance",
    "Perfect for Small Businesses"
];

const useCases = [
    "Startup Landing Pages",
    "Personal Portfolios",
    "Brochure Websites",
    "Event & Conference Pages",
    "Nonprofit or NGO Websites",
    "Small Business Showcases",
    "Resume or Profile Sites",
    "Temporary Campaign Sites"
];

const StaticWebsiteDevelopment = () => {
    return (
        <div className="static-container">
            <Helmet>
  <title>Static Website Design | APTech Solution</title>
  <meta 
    name="description" 
    content="We deliver fast, responsive, and SEO-friendly static websites that are perfect for businesses and personal use." 
  />
</Helmet>

            <h1 className="static-title">Static Website Development</h1>
            <p className="static-subtitle">
                Simple. Fast. Secure. We design and build static websites that are clean, lightning-fast, and easy to maintain.
            </p>

            <section className="static-section">
                <h2 className="section-heading">What is a Static Website?</h2>
                <p className="static-paragraph">
                    A static website is built using HTML, CSS, and JavaScript without any backend server or database. It’s perfect for businesses or individuals who want a fast and secure online presence without complexity.
                </p>
            </section>

            <section className="static-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">⚡</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="static-section">
                <h2 className="section-heading">Who Needs a Static Website?</h2>
                <div className="card-grid">
                    {useCases.map((item, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🌐</span>
                            <p>{item}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="static-section">
                <h2 className="section-heading">Why Choose a Static Website?</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">✅</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Need a Static Website?</h3>
                <p>Let us help you build a fast, clean, and professional website that works on every device.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Your Static Site</button>
                </a>
              
            </section>
        </div>
    );
};

export default StaticWebsiteDevelopment;
